import { parseDate } from "./parseDate";

export function getNowTimestamp(format) {
	let db_string = '';

	let formato = format.toUpperCase();
    const date = parseDate(new Date());
    
	if (formato.indexOf('YYYYMMDD') >= 0) {
		db_string += date.YYYY;
		db_string += date.MM;
		db_string += date.DD;
	}
	
	if (formato.indexOf('HH:MM') >= 0) {
		db_string += ' ';
		db_string += date.HH;
		db_string += ':'
		db_string += date.mm;
	}
	
	if (formato.indexOf('SS') >= 0) {
		db_string += ':';
		db_string += date.ss;
	}

	return db_string;
}
